export default "__VITE_ASSET__LPnOWK_C__"